export default [
  { to: 'oppenvard', title: 'Öppenvård' },
  { to: 'slutenvard', title: 'Slutenvård' },
  { to: 'profylax', title: 'Profylax' },
];
